import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Triangle = ({
  className,
  color = '#00304D',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      focusable="false"
      aria-hidden="true"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M8 9.5h8l-4 5-4-5Z" fill={color} />
    </svg>
  );
};
